import React from 'react';
import { BrandSymbol } from '../brand/BrandSymbol';
export function ConsultantPortrait({
  initials,
  name,
  className = ''
}: {
  initials: string;
  name: string;
  className?: string;
}) {
  return <div role="img" aria-label={`Placeholder portrait for ${name}`} className={`relative flex aspect-[4/5] items-center justify-center overflow-hidden bg-midnight ${className}`} data-id="element-61" data-mp="2iyq637n16ur8">
      <BrandSymbol size={260} className="absolute -bottom-12 -right-12 opacity-[0.08]" data-id="element-62" data-mp="1qb2l3rhum242" />
      <span className="font-display text-7xl font-semibold text-gold-300" data-id="element-63" data-mp="1v9duy2858cma">{initials}</span>
      <span className="absolute bottom-3 left-3 rounded bg-white/10 px-2 py-0.5 text-[11px] text-white/75" data-id="element-64" data-mp="2090bakj9q8zb">Portrait pending</span>
    </div>;
}